import { render, staticRenderFns } from "./TaskChat.vue?vue&type=template&id=4133d659&scoped=true&"
import script from "./TaskChat.vue?vue&type=script&lang=js&"
export * from "./TaskChat.vue?vue&type=script&lang=js&"
import style0 from "./TaskChat.vue?vue&type=style&index=0&id=4133d659&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133d659",
  null
  
)

export default component.exports